<template>
  <div class="parent_div">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <div id="content">
        <div>
          <section>
            <h2>パスワードリセット送信完了</h2>
            <div>
              パスワードリセットメールを自動送信しました。<br>
              メールに記載されたURLよりパスワードリセットにお進みください。
            </div>
            <p>
              ※受信制限をされている方は、「<span class="pickup">@domans.co.jp</span>」からのメールを受信許可に設定してください<br>
              ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。
            </p>
          </section>
          <div class="detail_btn2 btn_pos_center" @click="goLogin">ログイン画面へ戻る 〉〉</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import LoginForm from '../components/login/DcLoginForm'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-login': LoginForm
  },
  data () {
    return {
    }
  },
  methods: {
    goLogin: function () {
      this.$router.push({
        name: 'DcLogin'
      })
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcPasswordResetConfirm.vue